import styled from 'styled-components';

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${({ isDesktop }) => (isDesktop ? '101px 25px 0' : '40px 57px 0')};
`;

export default TextWrapper;
